// Module
var code = `<div class="jumbotron-surface library-media-labels-surface">

  <div class="jumbotron-panel-head">
    <div class="library-media-labels-head-main"
      ng-click="\$ctrl.isLabelsCollapsed = !\$ctrl.isLabelsCollapsed">
      <i class="fas fa-fw library-media-labels-chevron" aria-hidden="true"
        ng-class="{'fa-chevron-right': \$ctrl.isLabelsCollapsed, 'fa-chevron-down': !\$ctrl.isLabelsCollapsed}"></i>
      <span class="jumbotron-heading">Labels</span>
    </div>
  </div>

  <div class="library-media-labels-body" ng-show="!\$ctrl.isLabelsCollapsed">

    <datalist id="presetColors">
      <option ng-repeat="color in \$ctrl.colors" value="{{color}}"></option>
    </datalist>

    <!-- The colour of a label is data, so the template sets the border colour
         and the text colour inline. The rest of the chip is in the LESS file. -->
    <div class="library-media-labels-chips">
      <span class="jumbotron-chip library-media-labels-chip"
        ng-repeat="item in \$ctrl.MediaLabels | orderBy:'name' track by item.id"
        ng-style="{'border-color': item.color, 'color': item.color}">
        <button type="button" class="library-media-labels-name" ng-show="\$ctrl.editingId !== item.id"
          ng-click="\$ctrl.applyLabel(item.id)" title="Apply this label to the selected media">{{item.name}}</button>
        <span class="library-media-labels-fields" ng-show="\$ctrl.editingId === item.id">
          <input type="text" class="form-control form-control-sm library-media-labels-name-input"
            ng-model="item.name" aria-label="Label name"
            ng-keyup="\$event.keyCode == 13 && \$ctrl.saveLabel()" />
          <input type="color" class="form-control form-control-sm form-control-color library-media-labels-colour"
            ng-model="item.color" list="presetColors" aria-label="Label colour" />
        </span>
        <button type="button" class="library-media-labels-action" ng-show="!\$ctrl.editingId"
          ng-click="\$ctrl.toggleEdit(item.id)" aria-label="Rename label {{item.name}}" title="Rename label">
          <i class="fas fa-pencil" aria-hidden="true"></i>
        </button>
        <button type="button" class="library-media-labels-action" ng-show="\$ctrl.editingId === item.id"
          ng-click="\$ctrl.saveLabel()" ng-disabled="!\$ctrl.canSaveLabel()"
          aria-label="Save label {{item.name}}" title="Save label">
          <i class="fas fa-check" aria-hidden="true"></i>
        </button>
        <button type="button" class="library-media-labels-action is-danger"
          ng-click="\$ctrl.deleteLabel(item.id)" aria-label="Delete label {{item.name}}" title="Delete label">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </span>
      <!-- The new label is a chip too, in the colour the operator picks, with the
           same fields and marks as a label under rename. It takes the room of one
           label and not of a form. -->
      <span class="jumbotron-chip library-media-labels-chip library-media-labels-new"
        ng-style="{'border-color': \$ctrl.newLabel.color, 'color': \$ctrl.newLabel.color}">
        <span class="library-media-labels-fields">
          <input type="text" class="form-control form-control-sm library-media-labels-name-input"
            ng-model="\$ctrl.newLabel.name" placeholder="New label" aria-label="New label name"
            ng-keyup="\$event.keyCode == 13 && \$ctrl.createLabel()" />
          <input type="color" class="form-control form-control-sm form-control-color library-media-labels-colour"
            ng-model="\$ctrl.newLabel.color" list="presetColors" aria-label="New label colour" />
        </span>
        <button type="button" class="library-media-labels-action" ng-click="\$ctrl.createLabel()"
          ng-disabled="!\$ctrl.canCreateLabel()" aria-label="Create the label" title="Create the label">
          <i class="fas fa-check" aria-hidden="true"></i>
        </button>
        <button type="button" class="library-media-labels-action is-danger" ng-click="\$ctrl.resetNewLabel()"
          aria-label="Clear the new label" title="Clear the new label">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </span>
    </div>
  </div>
</div>
`;
// Exports
export default code;